export const TableSortDirectionType = { Asc: 'ASC', Desc: 'DESC' } as const;
export type TableSortDirectionType =
  (typeof TableSortDirectionType)[keyof typeof TableSortDirectionType];

export interface TableUISortModel {
  key?: string;
  direction?: TableSortDirectionType;
}

/** A click on a column title: unsorted → ascending → descending → unsorted. */
export function nextSortDirection(
  current: TableUISortModel | null | undefined,
  key: string,
): TableSortDirectionType | undefined {
  if (current?.key !== key || !current.direction) return TableSortDirectionType.Asc;
  return current.direction === TableSortDirectionType.Asc ? TableSortDirectionType.Desc : undefined;
}
